import FieldLabel from './ui/FieldLabel'
import DateInput from './ui/DateInput'
import { useEffect, useId, useState } from 'react'

const parts = value => {
    if (!value) return ['', '']
    const date = new Date(value)
    const pad = n => String(n).padStart(2, '0')
    return [`${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`, `${pad(date.getHours())}:${pad(date.getMinutes())}`]
}

export default function WorkerShiftDateTime({ prefix, value, onChange, disabled }) {
    const id = useId()
    const [[date, time], setParts] = useState(() => parts(value))
    useEffect(() => { if (value) setParts(parts(value)) }, [value])
    const update = (nextDate, nextTime) => {
        setParts([nextDate, nextTime])
        onChange(nextDate && nextTime ? new Date(`${nextDate}T${nextTime}`) : '')
    }
    return <div className='workerShiftDateTimeRow'>
        <div><FieldLabel className='fieldLabel' htmlFor={`${id}-date`}>{prefix} Date</FieldLabel>
            <DateInput id={`${id}-date`} type='date' value={date} disabled={disabled} onChange={event => update(event.target.value, time)} /></div>
        <div><FieldLabel className='fieldLabel' htmlFor={`${id}-time`}>{prefix} Time</FieldLabel>
            <DateInput id={`${id}-time`} type='time' value={time} disabled={disabled} onChange={event => update(date, event.target.value)} /></div>
    </div>
}
